import React from "react";

function SelectField({
  options = [],
  value = "",
  placeholder = "Select an option",
  onChange,
  className = "bg-[#FFFFFF]",
  errorMessage = "",
  register = () => ({}),
  ...rest
}) {
  return (
    <div className={`w-full h-full ${className} flex flex-col gap-1`}>
      <div
        className="flex items-center gap-2 rounded-md bg-[#FFFFFF] relative select-icon
"
      >
        <select
          // value={value}
          // onChange={onChange}
          {...register}
          {...rest}
          className="
            w-full h-full
            px-[14px] py-[12px] 
            gap-[10px] 
            rounded-md
            bg-[#FFFFFF] 
            focus:outline-none focus:border-blue-500
            placeholder-[#0000004D]
            placeholder:text-[14px] 
            placeholder:font-[400]
            appearance-none
            text-[13.3px]
          "
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {errorMessage && (
        <p className="text-red-400 text-left ml-1">{errorMessage}</p>
      )}
    </div>
  );
}

export default SelectField;
